import { SEARCH, SORT, FAVORITE, TYPES } from 'constants/FilterConstants';
import * as types from 'modules/mediaLibrary/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {'sort' | 'text' | 'favorite' | 'types'} FilterField */

/** @typedef {Record<FilterField, string | boolean | Array<string>>} MediaLibraryFiltersReducer */

/** @type {MediaLibraryFiltersReducer} */
const initialState = {
  [SORT]: 'createdOn,desc',
  [SEARCH]: '',
  [FAVORITE]: false,
  [TYPES]: [],
};

/**
 * @param {MediaLibraryFiltersReducer} state
 * @param {import('modules/mediaLibrary/types').SetMediaLibraryFilterAction} action
 * @returns {MediaLibraryFiltersReducer}
 */
const setFilter = (state, { payload: { field, value } }) => ({
  ...state,
  [field]: value,
});
/**
 * @returns {MediaLibraryFiltersReducer}
 */
const resetFilter = state => ({ ...initialState, [SORT]: state[SORT], [SEARCH]: state[SEARCH] });

/**
 * @param {MediaLibraryFiltersReducer} state
 * @param {import('modules/mediaLibrary/types').SetMediaLibraryFilterAction} action
 * @returns {MediaLibraryFiltersReducer}
 */
const removeFilter = (state, { payload: { field, value } }) => ({
  ...state,
  [field]: field === TYPES ? state[field].filter(item => item !== value) : state[field] !== value,
});

const dashboardFiltersReducer = source =>
  createReducer(initialState, {}, [
    {
      matcher: ({ type, meta }) => type === types.SET_MEDIA_LIBRARY_FILTER && meta.source === source,
      reducer: setFilter,
    },
    {
      matcher: ({ type, meta }) => type === types.CLEAR_MEDIA_LIBRARY_FILTERS && meta.source === source,
      reducer: resetFilter,
    },
    {
      matcher: ({ type, meta }) => type === types.REMOVE_MEDIA_LIBRARY_FILTER && meta.source === source,
      reducer: removeFilter,
    },
  ]);

export default dashboardFiltersReducer;
